import React from 'react';

const AnimeProduction = ({ anime }) => {
  return (
    <div className="tab-content production-content">
      <div className="production-grid">
        <ProductionGroup 
          title="Studios" 
          items={anime.studios} 
        />

        <ProductionGroup 
          title="Producers" 
          items={anime.producers} 
        />

        <ProductionGroup 
          title="Licensors" 
          items={anime.licensors} 
          emptyMessage="None listed" 
        />
      </div>
    </div>
  );
};

const ProductionGroup = ({ title, items, emptyMessage = "N/A" }) => {
  // Handle both the old format (array of strings) and new format (array of objects)
  const renderItems = () => {
    if (!items || items.length === 0) {
      return <span className="na">{emptyMessage}</span>;
    }
    
    // Check if items is an array of objects with a 'name' property
    if (typeof items[0] === 'object' && items[0] !== null && 'name' in items[0]) {
      return items.map((item, index) => (
        <span key={index} className="tag">{item.name}</span>
      ));
    } 
    // Old format (array of strings)
    else {
      return items.map((item, index) => (
        <span key={index} className="tag">{item}</span>
      ));
    }
  };

  return (
    <div className="production-group">
      <h4>{title}</h4>
      <div className="tags">
        {renderItems()}
      </div>
    </div>
  );
};

export default AnimeProduction;